export const GIT_COMMIT = '723dfac549d7a1efa38e65cf16aaa78bcdad0e26';
